export const isProdState = process.env.NEXT_PUBLIC_PROD_STATE === 'true';
export const STAGING_ENV = process.env.NEXT_PUBLIC_URL === 'https://staging.lorium.online';
